import { Order, VisibleColumnSpec } from "@/types";

export const SNAPSHOT_ORDER_COLUMNS: VisibleColumnSpec<Order, "actions" | "icon" | "product" | "lastPrice">[] = [
  "icon",
  "created",
  { id: "salesItem", breakpoint: "mantine-visible-from-xl" },
  "company",
  "product",
  { id: "amount", breakpoint: "mantine-visible-from-sm" },
  { id: "remainingAmount", breakpoint: "mantine-visible-from-lg" },
  { id: "finalAmount", breakpoint: "mantine-visible-from-md" },
  "status",
  { id: "lastPrice", breakpoint: "mantine-visible-from-lg" },
  { id: "fullLoad", breakpoint: "mantine-visible-from-lg" },
  // { id: "orderCurrency", breakpoint: "mantine-visible-from-lg" },
  // Replace <CURRENCY> with the runtime currency (e.g. `totalPriceWithFee.EUR`)
  "actions",
];
